<template>
  <div>
    <div v-if="type === 'card'" style="display: flex">
      <div v-for="index in count" :key="index">
        <div class="border-round border-1 surface-border p-4 surface-card">
          <div class="flex mb-3">
            <Skeleton shape="circle" size="4rem" class="mr-2" />
            <div>
              <Skeleton width="10rem" class="mb-2" />
              <Skeleton width="5rem" class="mb-2" />
              <Skeleton height=".5rem" />
            </div>
          </div>
          <Skeleton width="100%" height="150px" />
          <div class="flex justify-content-between mt-3">
            <Skeleton width="4rem" height="2rem" />
            <Skeleton width="4rem" height="2rem" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="type === 'line'">
      <Skeleton :width="width" class="mb-2" />
    </div>
    <div v-if="type === 'map'">
      <Skeleton :height="mapHeight" width="100%" />
    </div>
    <div
      v-if="type === 'verticalGraph'"
      style="display: flex; align-items: flex-end; justify-content: center; width: 100%"
    >
      <Skeleton height="300px" width="10px" style="margin-right: 5px" />
      <Skeleton height="200px" width="10px" style="margin-right: 5px" />
      <Skeleton height="100px" width="10px" style="margin-right: 5px" />
      <Skeleton height="400px" width="10px" style="margin-right: 5px" />
      <Skeleton height="300px" width="10px" style="margin-right: 5px" />
      <Skeleton height="200px" width="10px" style="margin-right: 5px" />
      <Skeleton height="300px" width="10px" style="margin-right: 5px" />
      <Skeleton height="200px" width="10px" style="margin-right: 5px" />
      <Skeleton height="100px" width="10px" style="margin-right: 5px" />
      <Skeleton height="400px" width="10px" style="margin-right: 5px" />
      <Skeleton height="300px" width="10px" style="margin-right: 5px" />
      <Skeleton height="200px" width="10px" style="margin-right: 5px" />
      <Skeleton height="300px" width="10px" style="margin-right: 5px" />
      <Skeleton height="200px" width="10px" style="margin-right: 5px" />
      <Skeleton height="100px" width="10px" style="margin-right: 5px" />
      <Skeleton height="400px" width="10px" style="margin-right: 5px" />
      <Skeleton height="300px" width="10px" style="margin-right: 5px" />
      <Skeleton height="200px" width="10px" style="margin-right: 5px" />
    </div>
    <div
      v-if="type === 'horizontalGraph'"
      style="
        display: flex;
        align-items: flex-end;
        justify-content: center;
        transform: rotate(90deg);
        margin-top: 30px;
        padding: 30px;
      "
    >
      <Skeleton height="150px" width="10px" style="margin-right: 5px" />
      <Skeleton height="100px" width="10px" style="margin-right: 5px" />
      <Skeleton height="50px" width="10px" style="margin-right: 5px" />
      <Skeleton height="200px" width="10px" style="margin-right: 5px" />
      <Skeleton height="150px" width="10px" style="margin-right: 5px" />
      <Skeleton height="100px" width="10px" style="margin-right: 5px" />
      <Skeleton height="150px" width="10px" style="margin-right: 5px" />
      <Skeleton height="100px" width="10px" style="margin-right: 5px" />
      <Skeleton height="50px" width="10px" style="margin-right: 5px" />
      <Skeleton height="200px" width="10px" style="margin-right: 5px" />
      <Skeleton height="150px" width="10px" style="margin-right: 5px" />
      <Skeleton height="100px" width="10px" style="margin-right: 5px" />
      <Skeleton height="150px" width="10px" style="margin-right: 5px" />
      <Skeleton height="100px" width="10px" style="margin-right: 5px" />
      <Skeleton height="50px" width="10px" style="margin-right: 5px" />
      <Skeleton height="200px" width="10px" style="margin-right: 5px" />
      <Skeleton height="150px" width="10px" style="margin-right: 5px" />
      <Skeleton height="100px" width="10px" style="margin-right: 5px" />
    </div>
    <div v-if="type === 'list'">
      <div>
        <Skeleton :width="listWidth.firstLine" class="mb-2" />
        <Skeleton :width="listWidth.secondLine" class="mb-2" />
        <Skeleton :height="listHeight.thirdLine" />
      </div>
      <div style="margin-top: 15px">
        <Skeleton :width="listWidth.firstLine" class="mb-2" />
        <Skeleton :width="listWidth.secondLine" class="mb-2" />
        <Skeleton :height="listHeight.thirdLine" />
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from 'primevue/skeleton'
export default {
  name: 'CustomSkeleton',
  components: {
    Skeleton,
  },
  props: {
    type: String,
    width: String,
    count: {
      type: Number,
      default: 1,
    },
    listWidth: {
      type: Object,
      default: () => ({
        firstLine: '600px',
        secondLine: '500px',
      }),
    },
    listHeight: {
      type: Object,
      default: () => ({
        thirdLine: '100px',
      }),
    },
    mapHeight: {
      type: String,
      default: '400px',
    },
  },
}
</script>

<style>
.p-skeleton {
  background-color: #64b4c8 !important;
}
</style>
